<template>
  <div class="pt-2" v-bind:style="{ background: setting.background_color }">
    <div class="row mx-0">
      <div class="col-12">
        <div class="feedback-header">
          <img src="../assets/bubble.svg" alt="" />
          <p>Select a Feedback Option Below:</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0" v-if="Object.keys(feedback).length !== 0 && feedback.settings.enabled_expired_at === 1">
      <div class="col-12">
        <count-down v-if="feedback.settings.expired_at" :date="feedback.settings.expired_at"></count-down>
      </div>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="panel">
          <a class="collapse-btn collapsed d-flex align-items-center justify-content-between" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample" v-on:click="collapseClick">
            <div class="btn-label d-flex align-items-center">
              <div class="icon d-flex align-items-center">
                <img src="../assets/info-icon.svg" alt="" />
              </div>
              <p class="mb-0 title">How It Works</p>
            </div>
            <img src="../assets/arrow-up.svg" class="arrow-icon" alt="" />
          </a>
          <div class="collapse collapse-content" id="collapseExample">
            <p><span>•</span> Select an option below to submit your feedback</p>
            <p><span>•</span> Answer each question</p>
            <p><span>•</span> Feedback takes less than 2 mins total on average</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0" v-bind:key="options.option_unique_id" v-for="options in feedback.options">
      <div class="col-12">
        <div class="feedback-option">
          <div class="panel">
            <div class="head d-flex align-items-center">
              <img src="../assets/bubble.svg" alt="" />
              <p>{{ options.option_title }}</p>
            </div>
            <div class="reward" v-if="options.is_offer_reward && options.reward_settings">
              <div class="d-flex align-items-center justify-content-between">
                <div class="reward-head d-flex align-items-center">
                  <img src="../assets/confetti.svg" width="16" alt="" />
                  <p>Reward:</p>
                </div>
                <a href="#" data-toggle="modal" :reward_detail="options.reward_settings.reward_detail" :data-target="'#exampleModal' + options.feedback_option_id" class="reward-detail d-flex align-items-center">
                  <p>Details</p>
                  <img src="../assets/info-icon-primary.svg" width="16" alt="" />
                </a>
              </div>
              <h5 class="reward-title">
                {{ options.reward_settings.reward_title }}
              </h5>
              <div class="remaining-reward d-flex align-items-center" v-if="options.reward_settings.is_reward_quantity">
                <div class="badge">
                  {{ options.reward_settings.reward_quantity - (options.used_rewards ? options.used_rewards : 0) }}
                </div>
                <p class="mb-0">Rewards Remaining</p>
              </div>
            </div>
            <p class="feedback-title">Answer the following questions:</p>
            <div class="question" v-bind:key="question.option_question_id" v-for="(question, index) in options.questions">
              <a class="collapse-btn d-flex align-items-center justify-content-between" data-toggle="collapse" :href="'#' + question.unique_id" role="button" aria-expanded="false" aria-controls="collapseExample">
                <div class="btn-label d-flex align-items-center">
                  <div class="icon d-flex align-items-center">
                    <img src="../assets/question-icon.svg" alt="" />
                  </div>
                  <p class="mb-0 title">Question {{ index + 1 }}</p>
                </div>
                <img src="../assets/arrow-up.svg" class="arrow-icon" alt="" />
              </a>
              <div class="collapse collapse-content" :id="question.unique_id">
                <h5 class="question-title">{{ question.title }}</h5>
              </div>
            </div>
            <a href="javascript:void(0)" @click="moveToSelectedOption(options.option_unique_id, options.questions.length ? options.questions[0].option_question_id : null, $fromAdminSide, options)" class="btn action-btn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.58984 16.34L13.1698 11.75L8.58984 7.16L9.99984 5.75L15.9998 11.75L9.99984 17.75L8.58984 16.34Z" fill="" />
              </svg>

              <p class="mb-0">Select This Option</p>
            </a>
          </div>
        </div>
        <div class="modal fade" :id="'exampleModal' + options.feedback_option_id" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered reward-modal">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#8997B1" />
                  </svg>
                </button>
                <h5 class="modal-title">Reward Details</h5>
                <p class="modal-desc" v-if="options.reward_settings" v-html="options.reward_settings.reward_detail"></p>
                <!-- <a href="https://www.acme.com/reward-3824" class="link"
              >https://www.acme.com/reward-3824</a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <button class="back-btn d-flex align-items-center p-0 border-0" @click="goBack">
          <div class="icon">
            <img src="../assets/angle-left.svg" alt="" />
          </div>
          <div class="text">
            <p class="mb-0">Back</p>
          </div>
        </button>
        <div class="d-flex align-items-center justify-content-center">
          <Branding></Branding>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";

import CountDown from "./CountDown";
import Branding from "./partials/branding.vue";

export default {
  name: "Feedback",
  data() {
    return {
      feedback: {},
      reward_detail: "",
      setting: {},
      user: {
        pixel_key: "",
        ip: "",
        location: "",
        agent: navigator.userAgent,
        current_page: encodeURIComponent(window.location.href),
      },
    };
  },
  components: {
    CountDown,
    Branding,
  },
  props: ["response"],
  created() {
    this.user.ip = this.$helpers.get_ip();
    this.user.location = this.$helpers.get_location_data(this.user.ip);
    if (this.$canary_load_url) {
      this.user.current_page = encodeURIComponent(this.$canary_load_url);
    } else {
      this.user.current_page = encodeURIComponent(window.location.href);
    }
    this.user.pixel_key = this.$session.get("pixelKey");
    console.log(this.user)
  },
  mounted() {
    // Vue.prototype.$currentScreen = "feedback";
    this.feedback = this.$session.get("response");
    this.setting = this.$session.get("response").settings;
    setTimeout(() => {
      this.$helpers.updateColorAccordingApi();
    });
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            this.feedback = this.$session.get("response");
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          } else if (event.data.option) {
            this.feedback = this.$session.get("response");
          }
        }
      },
      false
    );
  },
  methods: {
    goBack() {
      return this.$router.push("/");
    },
    collapseClick() {
      setTimeout(() => {
        this.$helpers.resizeIframeEvent();
      }, 500);
    },
    moveToSelectedOption(option_unique_id, option_question_id, fromAdmin, option) {
      if (option_unique_id && option_question_id && option && !fromAdmin) {
        this.$helpers.send_tracking_data({
          ...this.user,
          notification_id: option.notification_id,
          option_id: option.feedback_option_id,
          type: "canary_feedback_question_tracking",
          subtype: "impression",
          unique_uuid: this.$session.get("uuid"),
          total_questions: option.questions.length,
        } ,     this.baseUrl = this.$session.get("baseUrl"));
        // console.log(option_question_id);
        this.$router.push({
          name: "QuestionView",
          params: {
            id: option_unique_id,
            qid: option_question_id,
          },
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.feedback-header {
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--title-color);
    margin: 0;
    margin-left: 8px;
  }
}
.timer {
  padding: 12px 14px 16px 12px;
  background: #ffffff;
  border-radius: 5px;
  .icon {
    margin-right: 44.5px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #313c4e;
    }

    .colon {
      padding: 4px 8px;
      p {
        font-size: 24px;
        line-height: 24px;
      }
    }

    .day {
      .number {
        font-size: 24px;
        line-height: 36px;
      }
      .title {
        font-size: 11px;
        line-height: 16px;
        letter-spacing: -0.02em;
      }
    }
  }
}
.panel {
  .collapse-btn {
    background: #ffffff;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 0px 0px;
    padding: 14px 16px;
    text-decoration: none;
    position: relative;
    z-index: 1;

    .btn-label {
      .icon {
        margin-right: 8px;
      }
      .title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #56657f;
      }
    }

    &[aria-expanded="true"] {
      .arrow-icon {
        transform: rotateZ(0deg);
      }
    }

    &[aria-expanded="false"] {
      .arrow-icon {
        transform: rotateZ(180deg);
      }
    }
  }
  .collapse-content {
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    padding: 24px 16px;
    text-align: left;

    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
      margin-bottom: 8px;
    }
  }
}
.feedback-option {
  .panel {
    background: #ffffff;
    border-radius: 4px;
    padding: 18px 10px;

    .head {
      margin-bottom: 14px;
      p {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.01em;
        color: #313c4e;
        margin: 0;
        margin-left: 8px;
      }
    }

    .reward {
      background: #ffffff;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
      border-radius: 5px;
      padding: 10px 15px 10px 10px;
      .reward-head {
        p {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 20px;
          color: #56657f;
          margin: 0;
          margin-left: 4px;
        }
      }
      .reward-detail {
        p {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 16px;
          color: var(--accent-color);
          margin: 0;
          margin-right: 4px;
        }
      }
      .reward-title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0.01em;
        color: #313c4e;
        text-align: left;
        margin: 10px 0px;
      }
      .remaining-reward {
        .badge {
          background: var(--accent-color);
          border-radius: 10px;
          padding: 0px 10px;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          text-align: left;
          letter-spacing: 0.01em;
          color: white;
          margin-right: 10px;
        }
        p {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: #2b3648;
        }
      }
    }

    .feedback-title {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
      margin: 16px 0px;
      text-align: left;
    }

    .question {
      margin-bottom: 16px;
      .collapse-btn {
        padding: 7px 16px;

        &[aria-expanded="true"] {
          .arrow-icon {
            transform: rotateZ(0deg);
          }
        }

        &[aria-expanded="false"] {
          .arrow-icon {
            transform: rotateZ(180deg);
          }
        }
      }
      .collapse-content {
        padding: 19px 16px 26px 16px;

        .question-title {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0.01em;
          color: #313c4e;
          margin-bottom: 8px;
        }

        .attachments {
          .title {
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 20px;
            letter-spacing: 0.01em;
            color: #8997b1;
            margin-bottom: 8px;
          }
          .type {
            border: 2px solid #f1f2f9;
            box-sizing: border-box;
            border-radius: 5px;
            padding: 6px 11px;
            text-align: center;
            margin-right: 8px;
            width: 100%;

            &:last-child {
              margin-right: 0px;
            }
          }
        }
      }
    }

    .action-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--accent-color);
      border-radius: 4px;
      color: var(--action-btn-color);
      width: 100%;
      padding: 12px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.24);
      svg {
        fill: var(--action-btn-color);
        margin-right: 8px;
      }
      .icon {
        margin-right: 8px;
      }

      p {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 24px;
        letter-spacing: 0.01em;
      }
    }
  }
}
.back-btn {
  margin-bottom: 35px;
  background: none;
  .icon {
    margin-right: 8px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
    }
  }
}
.copyright {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  padding: 4px 11px;
  background: #fff;
  margin-bottom: 15px;
  border-radius: 40px;
  .icon {
    margin-right: 4.84px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 3px;
  }
  .text {
    p {
      font-family: "Mulish", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;
      color: #8997b1;
    }
  }
}
a {
  text-decoration: none;
}
.reward-modal {
  .modal-body {
    padding: 32px;
    position: relative;
    text-align: left;

    .close {
      position: absolute;
      top: 18px;
      right: 15px;
      opacity: 1;
    }

    .modal-title {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.01em;
      color: #313c4e;
      margin-bottom: 18px;
    }

    .modal-desc {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #313c4e;
      margin: 0;
    }

    .link {
      color: var(--accent-color);
    }
  }
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 375px;
  }
}
</style>
